import React from 'react';
import { useTranslation } from 'react-i18next';

export interface UseCasesKPIsProps {
  /** Total number of use cases */
  totalUseCases: number;
  /** Number of completed use cases */
  completedUseCases: number;
  /** Average impact score (1-10) or null if not available */
  averageImpact: number | null;
  /** Number of active categories */
  activeCategories: number;
}

export const UseCasesKPIs: React.FC<UseCasesKPIsProps> = ({
  totalUseCases,
  completedUseCases,
  averageImpact,
  activeCategories,
}) => {
  const { t } = useTranslation();

  return (
    <div className="grid gap-4 md:grid-cols-4">
      <div className="rounded-xl border border-border bg-card p-4 shadow-sm">
        <div className="text-xs font-medium uppercase text-muted-foreground">
          {t('useCases.metrics.completed')}
        </div>
        <div className="mt-2 text-2xl font-semibold text-foreground">{completedUseCases}</div>
        <p className="mt-1 text-xs text-muted-foreground">
          {t('useCases.metrics.completedHelp')}
        </p>
      </div>
      <div className="rounded-xl border border-border bg-card p-4 shadow-sm">
        <div className="text-xs font-medium uppercase text-muted-foreground">
          {t('useCases.metrics.total')}
        </div>
        <div className="mt-2 text-2xl font-semibold text-foreground">{totalUseCases}</div>
        <p className="mt-1 text-xs text-muted-foreground">
          {t('useCases.metrics.totalHelp')}
        </p>
      </div>
      <div className="rounded-xl border border-border bg-card p-4 shadow-sm">
        <div className="text-xs font-medium uppercase text-muted-foreground">
          {t('useCases.metrics.avgImpact')}
        </div>
        <div className="mt-2 text-2xl font-semibold text-foreground">
          {averageImpact !== null ? `${averageImpact.toFixed(1)}/10` : '—'}
        </div>
        <p className="mt-1 text-xs text-muted-foreground">
          {t('useCases.metrics.avgImpactHelp')}
        </p>
      </div>
      <div className="rounded-xl border border-border bg-card p-4 shadow-sm">
        <div className="text-xs font-medium uppercase text-muted-foreground">
          {t('useCases.metrics.activeMatrices')}
        </div>
        <div className="mt-2 text-2xl font-semibold text-foreground">{activeCategories}</div>
        <p className="mt-1 text-xs text-muted-foreground">
          {t('useCases.metrics.activeMatricesHelp')}
        </p>
      </div>
    </div>
  );
};
